export const TILESERVER = process.env.REACT_APP_TILESERVER || 'https://seat-crawler.herokuapp.com';
export const CDN = process.env.REACT_APP_TILE_CDN || 'https://maps.metaseat.com';



// WEBPACK FOOTER //
// ./src/config.js